import React, { Component } from "react";

import ApolloClient from "apollo-boost";
import gql from "graphql-tag";
import { Row, Col } from "react-bootstrap";
import Config from "../../config/config";
import { addToDataLayerGTM } from '../../utils/addToDataLayerGTM';


const lms_client = new ApolloClient({
  uri: Config.baseUrl + "/api/v1/lms/"
});

const GET_FAVORITE_COURSE = gql`
  query favoriteCourse($course_id: Int!) {
    course_favorite_by_user(course_id: $course_id) {
      id
    }
  }
`;

const GET_LIKE_COURSE = gql`
  query likeCourse($course_id: Int!) {
    course_like_by_user(course_id: $course_id) {
      id
    }
  }
`;

const TOGGLE_LIKE_COURSE = gql`
  mutation insertLikeCourse($course_id: Int!) {
    toggleUserLikeCourse(input:{course_id:$course_id}){
      id
    }
  }
`;

const TOGGLE_FAVORITE_COURSE = gql`
  mutation insertFavoriteCourse($course_id: Int!) {
    toggleUserFavoriteCourse(input:{course_id:$course_id}){
      id
    }
  }
`;

export class SidebarCourse extends Component {
  constructor(props) {
    super(props);
    this.state = {
      like: false,
      favorite: false
    };
  }

  minutes_with_leading_zeros(minutes)
  {
    return (minutes < 10 ? '0' : '') + minutes;
  }

  componentDidMount() {
    const courseDuration = `${this.props.course.hours ? this.props.course.hours : 0}:${this.minutes_with_leading_zeros(this.props.course.minutes ? this.props.course.minutes : 0)}`
    // Elemento para auxílio nas análises do GTM(Google Tag Manager)
    if(this.props.isTrail) {
      if(!window.customData.curso.item) {
        window.customData.curso.item = {};
      }
      window.customData.curso.item.tempo = courseDuration;
    } else {
      window.customData.curso.tempo = courseDuration;
    }

    lms_client.query({
        variables:{course_id: this.props.course.id },
        query: GET_FAVORITE_COURSE
    })
    .then(
      result => {
        this.setState({
          favorite: (result.data.course_favorite_by_user ? true : false)
        });

        // Elemento para auxílio nas análises do GTM(Google Tag Manager)
        if (this.props.isTrail) {
          window.customData.curso.item.favorito = result.data.course_favorite_by_user ? true : false;
        } else {
          window.customData.curso.favorito = result.data.course_favorite_by_user ? true : false;
        }
      }
    );

    lms_client.query({
        variables:{course_id: this.props.course.id },
        query: GET_LIKE_COURSE
    })
    .then(
      result => {
        this.setState({
          like: (result.data.course_like_by_user ? true : false)
        });

        // Elemento para auxílio nas análises do GTM(Google Tag Manager)
        if (this.props.isTrail) {
          window.customData.curso.item.curtido = result.data.course_like_by_user ? true : false;
        } else {
          window.customData.curso.curtido = result.data.course_like_by_user ? true : false;
        }
      }
    );
  }

  setLike() {
    const date = new Date();
    const formattedDate = `${date.getFullYear()}-${date.getMonth() + 1}-${date.getDate()}`
    // Google Tag Manager
    const dataLayer = {
      event: 'solicitacao_servico',
      nome_servico: this.state.like ? 'descurtido': 'curtido',
      nome_curso: this.props.course.title,
      data_servico: formattedDate,
      produto: this.props.course.title,
      brand: 'porto seguro',
      retorno: '',
      descricao: this.state.like ? 'curso descurtido': 'curso curtido',
    }


    lms_client.mutate({
      variables:{course_id: this.props.course.id },
      mutation: TOGGLE_LIKE_COURSE
    }).then(result => {
      if(result.errors){
        dataLayer.retorno = 'erro';
        dataLayer.descricao = `erro ao ${this.state.like ? 'descurtir' : 'curtir'} curso`
      }
      else {
        dataLayer.retorno = 'sucesso';
      }
    });

    addToDataLayerGTM(dataLayer);
    this.setState(state => ({
      ...state,
      like: !this.state.like
    }));
  }

  setFavorite() {

    const date = new Date();
    const formattedDate = `${date.getFullYear()}-${date.getMonth() + 1}-${date.getDate()}`

    // Google Tag Manager
    const dataLayer = {
      event: 'solicitacao_servico',
      nome_servico: this.state.favorite ? 'desfavoritado': 'favoritado',
      nome_curso: this.props.course.title,
      data_servico: formattedDate,
      produto: this.props.course.title,
      brand: 'porto seguro',
      retorno: '',
      descricao: this.state.favorite ? 'curso desfavoritado': 'curso favoritado',
    }

    lms_client.mutate({
      variables:{course_id: this.props.course.id },
      mutation: TOGGLE_FAVORITE_COURSE
    }).then(result => {
      if(result.errors){
        dataLayer.retorno = 'erro';
        dataLayer.descricao = `erro ao ${this.state.like ? 'desfavoritar' : 'favoritar'} curso`
      }
      else {
        dataLayer.retorno = 'sucesso';
      }
    });

    addToDataLayerGTM(dataLayer);
    this.setState(state => ({
      ...state,
      favorite: !this.state.favorite
    }));

  }

  render() {

    return (
      <div className="sidebar-course">
        <Row>
          <Col md={4}>
            <div className="sidebar-course-item">
              <i className="pe-7s-look"></i>
              <div><span>{this.props.course.hours ? this.props.course.hours : 0}:{this.minutes_with_leading_zeros(this.props.course.minutes ? this.props.course.minutes : 0)}</span></div>
              <div>Tempo de Curso</div>
            </div>
          </Col>
          <Col md={4}>
            <div className={this.state.like ? 'active' : ''}>
              <div className="sidebar-course-item course-like" data-gtm-type="click" data-gtm-clicktype="card" data-gtm-name="curtir conteúdo" onClick={() => this.setLike()}>
                <i className="pe-7s-like2"></i>
                <div>Curtir conteúdo</div>
              </div>
            </div>
          </Col>
          <Col md={4}>
            <div className={this.state.favorite ? 'active' : ''}>
              <div className="sidebar-course-item course-favorite" data-gtm-type="click" data-gtm-clicktype="card" data-gtm-name="adicionar a favoritos" onClick={() => this.setFavorite()}>
                <i className="pe-7s-star"></i>
                <div>Adicionar aos favoritos</div>
              </div>
            </div>
          </Col>
        </Row>
      </div>
    );
  }
}

export default SidebarCourse;



// WEBPACK FOOTER //
// ./src/components/Sidebar/SidebarCourse.jsx